import type { AuxiliaryActivitiesGroupRow } from './AuxiliaryActivitiesGroupTable';
import type { EquipmentGroupRow } from './EquipmentGroupTable';
import type { FixedTimeGroupRow } from './FixedTimeGroupTable';
import type { LaborGroupRow } from './LaborGroupTable';
import type { MaterialGroupRow } from './MaterialGroupTable';
import type { TimeOfTransportGroupRow } from './TimeOfTransportGroupTable';

export const auxiliaryActivitiesGroupTableMock: AuxiliaryActivitiesGroupRow[] =
  [
    {
      code: '605604',
      description:
        'Argamassa de solo-cimento com 10% de cimento e material de jazida - preparo e injeção em tunnel liner',
      quantity: 0.7854,
      unit: 'M3',
      unitPrice: 379.94,
      hourlyCost: 298.4,
    },
    {
      code: '4816001',
      description:
        'Escavação manual de tunnel liner em material de 2a categoria',
      quantity: 5.30929,
      unit: 'M3',
      unitPrice: 686.15,
      hourlyCost: 3642.97,
    },
    {
      code: '4816003',
      description: 'Iluminação provisória para tunnel liner',
      quantity: 1,
      unit: 'M',
      unitPrice: 38.41,
      hourlyCost: 38.41,
    },
    {
      code: '3806428',
      description:
        'Plataforma de trabalho em aço tubular apoiada no solo - altura de até 4 m - utilização de 100 vezes - fornecimento, instalação e retirada',
      quantity: 0.03333,
      unit: 'M3',
      unitPrice: 35.97,
      hourlyCost: 1.2,
    },
    {
      code: '605606',
      description:
        'Sistema de escoramento telescópico regulável para tunnel liner',
      quantity: 4.52389,
      unit: 'M3',
      unitPrice: 14.84,
      hourlyCost: 67.13,
    },
    {
      code: '4816004',
      description: 'Ventilação provisória para tunnel liner',
      quantity: 1,
      unit: 'M',
      unitPrice: 51.32,
      hourlyCost: 51.32,
    },
  ];

export const equipmentGroupTableMock: EquipmentGroupRow[] = [
  {
    code: 'E9764',
    description: 'Grupo gerador - 7,2 kVA',
    quantity: 1,
    usageOperative: 1,
    usageIdle: 0,
    costOperative: 11.64,
    costIdle: 0.51,
    hourlyCost: 11.64,
  },
  {
    code: 'E9510',
    description:
      'Ventilador centrífugo baixa pressão com capacidade de 58 m3/min - 3,68 kW',
    quantity: 1,
    usageOperative: 1,
    usageIdle: 0,
    costOperative: 2.36,
    costIdle: 1.52,
    hourlyCost: 2.36,
  },
];

export const fixedTimeGroupTableMock: FixedTimeGroupRow[] = [
  {
    code: '4816001',
    description:
      'Escavação manual de tunnel liner em material de 2a categoria - Carga, manobra e descarga de agregados ou solos em caminhão basculante de 6 m3 - carga manual e descarga livre',
    referenceCode: '5915476',
    quantity: 11.06987,
    unit: 'T',
    unitPrice: 27.65,
    unitCost: 306.08,
  },
  {
    code: 'M2786',
    description:
      'Chapa metálica corrugada galvanizada para tunnel liner - E = 3,4 mm e D = 2,4 m - Carga, manobra e descarga de materiais diversos em caminhão carroceria de 15 t - carga e descarga manuais',
    referenceCode: '5914655',
    quantity: 0.289,
    unit: 'T',
    unitPrice: 32.22,
    unitCost: 9.31,
  },
];

export const laborGroupTableMock: LaborGroupRow[] = [
  {
    code: 'P9859',
    description: 'Trabalhador de via',
    quantity: 22,
    unit: 'H',
    hourlyCost: 18.27,
    totalHourlyCost: 401.97,
  },
];

export const materialGroupTableMock: MaterialGroupRow[] = [
  {
    code: 'M2786',
    description:
      'Chapa metálica corrugada galvanizada para tunnel liner - E = 3,4 mm e D = 2,4 m',
    quantity: 1,
    unit: 'M',
    unitPrice: 12101.75,
    unitCost: 12101.75,
  },
  {
    code: 'M1797',
    description:
      'Fita de espuma EPDM para vedação com adesivo em uma face - E = 4 mm e L = 40 mm',
    quantity: 26.39092,
    unit: 'M',
    unitPrice: 3.08,
    unitCost: 81.25,
  },
];

export const timeOfTransportGroupTableMock: TimeOfTransportGroupRow[] = [
  {
    code: 'M2786',
    description:
      'Chapa metálica corrugada galvanizada para tunnel liner - E = 3,4 mm e D = 2,4 m',
    quantity: 0.289,
    unit: 'M',
    dmt: {
      ln: {
        auxiliaryCode: '59144419',
        dmtKm: 0,
        unitaryValue: 1.09,
        coefficient: 0,
      },
      rp: {
        auxiliaryCode: '5914464',
        dmtKm: 0,
        unitaryValue: 0.87,
        coefficient: 0,
      },
      p: {
        auxiliaryCode: '5914479',
        dmtKm: 0,
        unitaryValue: 0.72,
        coefficient: 0,
      },
      fe: {
        auxiliaryCode: '5914485',
        dmtKm: 0,
        unitaryValue: 0.5,
        coefficient: 0,
      },
    },
    hourlyCost: 0,
  },
  {
    code: '4816001',
    description:
      'Escavação manual de tunnel liner em material de 2a categoria - Carga, manobra e descarga de agregados ou solos em caminhão basculante de 6 m3 - carga manual e descarga livre',
    quantity: 11.06987,
    unit: 'M3',
    dmt: {
      ln: {
        auxiliaryCode: '5914314',
        dmtKm: 50,
        unitaryValue: 1.35,
        coefficient: 50,
      },
      rp: {
        auxiliaryCode: '5914329',
        dmtKm: 50,
        unitaryValue: 1.08,
        coefficient: 50,
      },
      p: {
        auxiliaryCode: '5914344',
        dmtKm: 50,
        unitaryValue: 0.89,
        coefficient: 50,
      },
      fe: {
        auxiliaryCode: '5914356',
        dmtKm: 0,
        unitaryValue: 0.72,
        coefficient: 0,
      },
    },
    hourlyCost: 1837.5984,
  },
];
